import React from 'react';

const TermsPage = () => {
  return (
    <div className="bg-black min-h-screen text-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-4xl font-bold text-yellow-400 mb-6">Terms of Service</h1>
        <p className="text-gray-300 mb-6">Last updated: {new Date().toLocaleDateString()}</p>

        <div className="space-y-6">
          <section>
            <h2 className="text-2xl font-bold text-yellow-400 mb-2">1. Introduction</h2>
            <p className="text-gray-300">These Terms of Service (the "Terms") govern your access to and use of the K.R.A platform, including websites, mobile applications, and services (collectively, the "Service"). By accessing or using the Service, you agree to be bound by these Terms.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-yellow-400 mb-2">2. Accounts</h2>
            <p className="text-gray-300">You must provide accurate information when creating an account. You are responsible for maintaining confidentiality of your login credentials and for all activities under your account.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-yellow-400 mb-2">3. Subscriptions and Payments</h2>
            <p className="text-gray-300">Subscription plans may be offered and billed on a recurring basis. By purchasing a subscription or product, you authorize K.R.A to charge your payment method. Refunds are handled in accordance with our refund policy.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-yellow-400 mb-2">4. Content and Intellectual Property</h2>
            <p className="text-gray-300">All content on the Service, including courses, text, graphics, logos, and software, is owned by K.R.A or its licensors and protected by applicable laws. You may not copy, distribute, or create derivative works without permission.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-yellow-400 mb-2">5. Acceptable Use</h2>
            <p className="text-gray-300">You agree not to misuse the Service, including by attempting to gain unauthorized access, interfering with the Service operations, or engaging in harassment or illegal activities.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-yellow-400 mb-2">6. Privacy</h2>
            <p className="text-gray-300">Our handling of personal data is described in our Privacy Policy. By using the Service, you consent to the collection and use of information as outlined therein.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-yellow-400 mb-2">7. Termination</h2>
            <p className="text-gray-300">We may suspend or terminate access to the Service at any time if you violate these Terms or for other reasons at our discretion.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-yellow-400 mb-2">8. Disclaimers and Limitation of Liability</h2>
            <p className="text-gray-300">The Service is provided "as is" without warranties of any kind. To the fullest extent permitted by law, K.R.A is not liable for any indirect, incidental, or consequential damages arising from your use of the Service.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-yellow-400 mb-2">9. Changes to Terms</h2>
            <p className="text-gray-300">We may update these Terms from time to time. Continued use of the Service after changes constitutes acceptance of the revised Terms.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-yellow-400 mb-2">10. Contact</h2>
            <p className="text-gray-300">Questions about these Terms can be sent to <a href="mailto:K.R.A_initiativeinc@outlook.com" className="text-yellow-400">K.R.A_initiativeinc@outlook.com</a>.</p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsPage;